import React from 'react';
import { TouchableOpacity, Image, StyleSheet } from 'react-native';
import AppHeader from './AppHeader';

const SharedHeader = ({ title, onBackPress, onNotificationPress, showNotificationIcon = true }) => {
  const right = showNotificationIcon ? (
    <TouchableOpacity style={styles.notificationButton} onPress={onNotificationPress} hitSlop={8}>
      <Image
        source={require('../../assets/icons/paper-icon.png')}
        style={styles.paperIcon}
        resizeMode="contain"
      />
    </TouchableOpacity>
  ) : null;

  return (
    <AppHeader
      title={title}
      onBack={onBackPress}
      right={right}
    />
  );
};

const styles = StyleSheet.create({
  notificationButton: {
    width: 44,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
  },
  paperIcon: {
    width: 24,
    height: 24,
  },
});

export default SharedHeader;
